import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=048b74be&scoped=true"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"
import style0 from "./Pie.vue?vue&type=style&index=0&id=048b74be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b74be",
  null
  
)

export default component.exports